export default class Pin {
	constructor(args) {
		this.ui = {
			group: $(args.group),
			inputs: $(args.group).find('input'),
			hiddenInput: $($(args.group).data('target')),
			onCompletePinEntered: args.onCompletePinEntered,
		}

		if(!this.ui.group.length) {
			return;
		}

		this.maxLength = this.ui.inputs.length;
		this.bindEvents();
	}

	bindEvents() {
		this.ui.inputs.on("keydown", this.onKeydown.bind(this));
		this.ui.inputs.on("paste", this.onPaste.bind(this));
	}

	onPaste(e) {
		console.log("Pin.onPaste", (e.originalEvent.clipboardData || window.clipboardData).getData('text'));
		
		e.preventDefault();
		e.stopPropagation();

		let pasted = (e.originalEvent.clipboardData || window.clipboardData).getData('text').replace(/\D/g, "").substring(0, this.maxLength);

		pasted.split("").forEach((n, i) => {
			this.ui.inputs[i].value = n;
		});

		this.getNextInput(pasted.length).focus();
		this.setHiddenInput();
	}

	onKeydown(e) {
		console.log("Pin.onKeydown", { key: e.key, keyCode: e.keyCode, ctrlKey: e.ctrlKey, metaKey: e.metaKey, shiftKey: e.shiftKey });

		const target = e.currentTarget;
		const currentIndex = this.ui.inputs.index(target);
		
		if(e.ctrlKey || e.metaKey) {
			return;
		}

		e.stopPropagation();
		e.preventDefault();

		if(e.keyCode == 8) { // Backspace
			if(target.value == "") {
				this.getPreviousInput(currentIndex).value = '';
				this.getPreviousInput(currentIndex).focus();
			}

			target.value = "";

		} else if((e.keyCode >= 48 && e.keyCode <= 57) || (e.keyCode >= 96 && e.keyCode <= 105)) { // Numbers - allow and go to next input
			target.value = e.key;
			this.getNextInput(currentIndex).focus();

		} else if(e.keyCode == 37 || (e.shiftKey && e.keyCode == 9)) { // Left arrow / shift+tab - go to previous input
			this.getPreviousInput(currentIndex).focus();

		} else if(e.keyCode == 39 || e.keyCode == 9) { // Right arrow / tab - go to next input
			this.getNextInput(currentIndex).focus();

		} else if(e.keyCode == 13) { // Enter - focus submit (even if not valid)
			if(this.ui.onCompletePinEntered) {
				this.ui.onCompletePinEntered(this.getCurrentPin());
			}
		}

		this.setHiddenInput();
	}

	getPreviousInput(currentIndex) {
		return this.ui.inputs[Math.max(0, currentIndex - 1)];
	}

	getNextInput(currentIndex) {
		// This means you can't skip past a blank field, i.e. you can't enter 1_34
		const inputtedPinLength = this.ui.inputs.filter(i => this.ui.inputs[i].value.length).length;
		const maxIndex = this.maxLength - 1;
		return this.ui.inputs[Math.min(maxIndex, inputtedPinLength, currentIndex + 1)];
	}

	setHiddenInput() {
		let pin = this.getCurrentPin();

		this.ui.hiddenInput.val(pin);

		if(this.ui.onCompletePinEntered && pin.length == this.maxLength) {
			this.ui.onCompletePinEntered(pin);
		}
	}

	getCurrentPin() {
		let pin = "";

		this.ui.inputs.each((i,el) => {
			pin += el.value;
		});

		return pin;
	}
}